import {CROSS_BREAKPOINT, SMALL , LARGE } from './breakpoint-controller'
let win;
let flkty;
let serviceSlider , testimonialSlider , testimonialSliderImage, testimonialSliderImageLayout , logoSlider , isPostFlickity;
let $logoSlider;
let isLogoFlickity;
let $testimonialSliderImage, $resourceSlider;
function onDocumentReady() {
    win = $(window);
    serviceSlider = $('.service-list-section .services');
    testimonialSlider = $('.layout-testimonial-counter .testimonial-items');
    testimonialSliderImageLayout = $('.layout-testimonial-image-background');
    testimonialSliderImage = $('.layout-testimonial-image-background .testimonial-items');
    logoSlider = $('.layout-logo-bar .logo-bar');
    isLogoFlickity = false;

    //Services Image Slider
    serviceSlider.each(function() {
        if($(this).find('.image').length > 1 ){
            $(this).find('.featured-image').flickity({
              cellAlign: 'left',
              pageDots: false,
              contain: true
            });
        }
    });

    //Testimonial Slider
    if(testimonialSlider.find('.testimonial-item').length > 1 ){
        testimonialSlider.flickity({
          cellAlign: 'left',
          pageDots: false,
          adaptiveHeight: true,
          contain: true
        });
    }

    //Testimonial Slider With Background
    if(testimonialSliderImage.find('.testimonial-item').length > 1 ){
        $testimonialSliderImage = testimonialSliderImage.flickity({
          cellAlign: 'left',
          pageDots: false,
          contain: true
        });
    }
    if(testimonialSliderImage.find('.testimonial-item').length > 0){
        flkty = $testimonialSliderImage.data('flickity');
        setbackground();
        testimonialSliderImage.on( 'select.flickity', function() {
            setbackground();
        });
    }
    //History Slider
    $('.history-slider-nav').flickity({
        asNavFor: '.history-slider',
        contain: true,
        prevNextButtons: false,
        adaptiveHeight: true,
        pageDots: false
    });

    $('.history-slider').flickity({
        prevNextButtons: true,
        pageDots: false
    });

    logoSliderInit();
    relatedPostSlider();
    $(window).on(CROSS_BREAKPOINT, logoSliderInit);
    $(window).on(CROSS_BREAKPOINT, relatedPostSlider);

}

//Change Testimonial Slider Bacground Image
function setbackground(){
    testimonialSliderImageLayout.addClass('background-hide');
    var background = flkty.selectedElement.attributes.dataImage.nodeValue;
    setTimeout(function() { testimonialSliderImageLayout.removeClass('background-hide').css('backgroundImage', 'url("'+background+'")');}, 400)
}

//Logo Slider Initialize
function logoSliderInit() {
    if (win.width() <= LARGE) {
        if(isLogoFlickity) {
            $logoSlider.flickity('destroy');
        }

        isLogoFlickity = true;

        $logoSlider = logoSlider.flickity({
          cellAlign: 'center',
          wrapAround: false,
          pageDots: false,
          contain: true,
          groupCells: 3
        });
    }
    if(win.width() <= SMALL){
        if(isLogoFlickity) {
            $logoSlider.flickity('destroy');
        }
        isLogoFlickity = true;
        $logoSlider = logoSlider.flickity({
          cellAlign: 'left',
          wrapAround: false,
          pageDots: false,
          contain: true,
          groupCells: 2
        });
    }
    else {
        if(isLogoFlickity) {
            $logoSlider.flickity('destroy');
        }
        if(logoSlider.find('.logo').length > 5 ){
            $logoSlider = logoSlider.flickity({
              cellAlign: 'left',
              wrapAround: false,
              pageDots: false,
              contain: true,
              groupCells: true
            });
        }
    }
}

//Related Post Slider
function relatedPostSlider() {
	var sliderCount = $('.related-posts .post-card').length;
	if (win.width() <= LARGE) {
		if(sliderCount > 2){
			if(isPostFlickity) {
				$resourceSlider.flickity('destroy');
			}
			isPostFlickity = true;
			$resourceSlider = $('.related-posts .post-list').flickity({
				contain: true,
				pageDots: false,
				prevNextButtons: true,
				wrapAround: false,
				cellAlign: "left",
				arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 }
			});
		}
	}
	else if(isPostFlickity) {
		isPostFlickity = false;
		$resourceSlider.flickity('destroy');
	}
}
$(onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/slider-controller.js